const DATA_TYPES = ['string', 'number', 'date', 'boolean']

export default DATA_TYPES
